import { nanoid } from '@/lib/nanoid'

// Generates a random ID string of the given length (default 8)
export function randomId(): string {
	return `id_${nanoid()}`
}
